angular.module( 'acme.view.application.modals.membership', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.modals.membership.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipModal = {
        name: 'application.modals.membership',
        url: '/modals/membership',
        views: {
          "main": {
            controller: 'MembershipModalController',
            // Assumes the view is entirely self contained
            templateUrl: 'common/views/modals/confirm/membership.tpl.html'
          }
        },
        data: {
          pageTitle: '  ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipModal);
});
